import { FC, PropsWithChildren } from 'react';
import './page-title.styles.scss';

export const PageTitle: FC<PropsWithChildren> = (props) => (
  <h2 className="page-title">
    {props.children}
  </h2>
);
